import type { ContractorTranslation } from './en';

export const ru: ContractorTranslation = {
  common: {
    cancel: 'Отмена',
    save: 'Сохранить',
    retry: 'Повторить',
    download: 'Скачать',
    continue: 'Продолжить',
    yes: 'Да',
    no: 'Нет',
    genericError: 'Что-то пошло не так. Попробуйте ещё раз.',
    networkError: 'Не удалось подключиться к DubForge. Проверьте подключение к интернету.',
  },
  app: {
    tagline: 'Задания на дубляж, файлы и проверки в одном месте.',
    startupFailed: 'Не удалось запустить DubForge',
    notFoundTitle: 'Страница не найдена',
    notFoundBody: 'Такой страницы нет, или у вас нет к ней доступа.',
    goHome: 'На главную',
    crashTitle: 'Что-то пошло не так',
    crashBody: 'Попробуйте перезагрузить страницу.',
    reload: 'Перезагрузить',
  },
  language: {
    label: 'Язык',
    change: 'Сменить язык',
  },
  welcome: {
    title: 'Добро пожаловать в DubForge',
    body: 'Выберите язык. Он будет использоваться в DubForge и в уведомлениях Discord.',
    changeLater: 'Его можно изменить в любой момент в меню языка в правом верхнем углу.',
  },
  nav: {
    myAssignments: 'Мои задания',
    openMenu: 'Открыть меню',
    account: 'Аккаунт',
    notificationEmail: 'Почта для уведомлений',
    signOut: 'Выйти',
    roleAdmin: 'Администратор',
    roleContractor: 'Озвучка',
    lightMode: 'Светлая тема',
    darkMode: 'Тёмная тема',
  },
  login: {
    signIn: 'Войти через Discord',
    onlyInvited: 'Войти могут только аккаунты Discord, добавленные владельцем канала.',
    signingIn: 'Выполняется вход…',
    backToSignIn: 'Вернуться ко входу',
    failed: 'Не удалось войти. Попробуйте ещё раз.',
  },
  authErrors: {
    not_invited: 'Этот аккаунт Discord не добавлен в DubForge. Попросите владельца канала добавить вас.',
    access_off: 'Ваш доступ к DubForge отключён.',
    discord_only: 'Войти можно только через Discord.',
  },
  errors: {
    not_signed_in: 'Сеанс истёк. Войдите снова.',
    access_off: 'Ваш доступ к DubForge отключён.',
    admins_only: 'У вас нет прав на это действие.',
    not_found: 'Этот элемент не существует или больше недоступен.',
    invalid_request: 'В запросе есть ошибка. Проверьте данные и попробуйте ещё раз.',
    conflict: 'Такой элемент уже существует.',
    already_approved: 'Это задание уже одобрено, загружать больше ничего не нужно.',
    not_audio: 'Можно загружать только файлы WAV или MP3. Загрузите только свою голосовую дорожку.',
    upload_incomplete: 'Загрузка не завершилась. Попробуйте ещё раз.',
    discord_unreachable: 'Не удалось подключиться к Discord. Попробуйте позже.',
    server_error: 'На нашей стороне что-то пошло не так. Попробуйте ещё раз.',
  },
  notifications: {
    title: 'Уведомления',
    openWithCount: 'Уведомления (непрочитанных: {{count}})',
    markAllRead: 'Отметить все как прочитанные',
    empty: 'Пока ничего нет.',
  },
  emailSettings: {
    body: 'Мы пишем вам на почту, когда вы получаете новое задание и когда вашу работу проверили.',
    label: 'Адрес электронной почты',
    fromDiscord: 'Взят из вашего аккаунта Discord. Измените его, если хотите получать письма на другой адрес.',
    saved: 'Адрес сохранён',
    invalid: 'Введите корректный адрес электронной почты.',
    missing: 'Адрес электронной почты ещё не указан. Добавьте его, чтобы получать уведомления.',
  },
  status: {
    Assigned: 'Назначено',
    InProgress: 'В работе',
    Submitted: 'Ждёт проверки',
    ChangesRequested: 'Нужны правки',
    Approved: 'Одобрено',
  },
  assetKind: {
    package: 'Пакет для дубляжа (видео + голос + SFX)',
    video: 'Референсное видео (720p)',
    sfx: 'Дорожка SFX / музыки',
    voice: 'Оригинальная голосовая дорожка',
    script: 'Сценарий',
    other: 'Другое',
  },
  translation: {
    machine: 'Машинный перевод',
    showOriginal: 'Показать оригинал',
    showTranslation: 'Показать перевод',
  },
  uploader: {
    progress: '{{percent}}% из {{size}}',
    queued: 'В очереди на загрузку: {{count}}',
    keepOpen: 'Не закрывайте эту вкладку, пока загрузка не завершится.',
    cancelled: 'Загрузка отменена',
    done: 'Файл {{name}} загружен',
    failed: 'Ошибка загрузки: {{error}}',
  },
  my: {
    greeting: 'Здравствуйте, {{name}}',
    subtitle: 'Ваши задания на дубляж.',
    emptyTitle: 'Заданий пока нет',
    emptyBody: 'Когда вам назначат видео, вы получите сообщение в Discord, и задание появится здесь.',
    todo: 'Нужно сделать',
    waiting: 'Ждут проверки',
    done: 'Готово',
    updated: 'Обновлено {{when}}',
  },
  assignment: {
    back: 'Мои задания',
    dubIn: 'Дубляж: {{language}}',
    paid: 'Оплачено',
    next: {
      Assigned: 'Скачайте исходные файлы, запишите свой голос и загрузите сюда голосовую дорожку.',
      InProgress: 'Когда голосовая дорожка будет готова, загрузите её ниже.',
      Submitted: 'Ваш дубляж отправлен на проверку. Когда его проверят, вы получите сообщение в Discord.',
      ChangesRequested: 'Запрошены правки. Прочитайте отзыв ниже и загрузите новую версию.',
      Approved: 'Одобрено. Спасибо!',
    },
    notes: 'Примечания',
    sourceFiles: 'Исходные файлы',
    noFiles: 'Файлы ещё не загружены.',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'Один файл .mp4 с видео и двумя звуковыми дорожками: дорожка 1 — оригинальные реплики, дорожка 2 — SFX.',
    uploadTitle: 'Загрузите голосовую дорожку',
    voiceOnlyTitle: 'Только ваш голос',
    voiceOnlyBody:
      'Загружайте только записанный голос: без музыки, без звуковых эффектов и без оригинальной озвучки. Убедитесь, что длительность совпадает с оригиналом.',
    voiceOnlyConfirm: 'В этом файле только реплики.',
    dropLabel: 'Загрузите голосовую дорожку сюда',
    dropHint: 'Только WAV или MP3.',
    noteForReviewer: 'Комментарий для проверяющего (необязательно)',
    lengthTitle: 'Длительность не совпадает',
    lengthBody:
      'Длительность вашего файла — {{dub}}, а дорожки SFX — {{sfx}}. Если ваша дорожка начинается в другом месте или обрезана, она не совпадёт с видео. Всё равно загрузить?',
    uploadAnyway: 'Всё равно загрузить',
    chooseAnother: 'Выбрать другой файл',
    versions: 'Загруженные версии',
    nothingUploaded: 'Пока ничего не загружено.',
    version: 'Версия {{version}}',
    reviewApproved: 'Одобрено',
    reviewChanges: 'Нужны правки',
    reviewPending: 'Ждёт проверки',
    yourNote: 'Ваш комментарий:',
    feedback: 'Отзыв',
    listen: 'Прослушать',
    uploadedOn: '{{date}} · {{size}}',
    length: 'Длительность: {{duration}}',
  },
};
